import { Gist } from "@vita-learning/types";

export const GIST_SOURCES: Gist["source"][] = [
	"auto",
	"file",
	"manual",
	"note",
	"url",
];

export const GIST_MIN_MAX_LENGTH = 3;
